import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./monthlyPanchang.css";

function MonthlyPanchang() {
  const today = new Date();
  const defaultDate = `${String(today.getDate()).padStart(2, "0")}/${String(
    today.getMonth() + 1
  ).padStart(2, "0")}/${today.getFullYear()}`;

  const [params, setParams] = useState({
    date: defaultDate,
    time: "10:00",
    latitude: "24",
    longitude: "76",
    tz: "5.5",
  });

  const [language, setLanguage] = useState("en");
  const [result, setResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedDay, setSelectedDay] = useState(null);

  useEffect(() => {
    fetchMonthlyPanchang();
  }, [language]);

  const fetchMonthlyPanchang = () => {
    setLoading(true);
    setError("");
    setResult([]);

    fetch(
      `https://api.jyotishamastroapi.com/api/panchang/monthly_panchang?date=${params.date}&time=${params.time}&latitude=${params.latitude}&longitude=${params.longitude}&tz=${params.tz}&lang=${language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API Error: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data && data.response) setResult(data.response);
        else setError("No data found.");
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  // group by weeks (7 days per row)
  const chunkArray = (arr, size) => {
    const res = [];
    for (let i = 0; i < arr.length; i += size) res.push(arr.slice(i, i + size));
    return res;
  };

  const renderCalendar = () => {
    if (!result.length) return null;
    const weeks = chunkArray(result, 7);

    return (
      <div className="monthlyPanchang-calendar-grid">
        <div className="monthlyPanchang-calendar-header">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
            <div key={day} className="monthlyPanchang-calendar-cell header">
              {day}
            </div>
          ))}
        </div>

        {weeks.map((week, wi) => (
          <div key={wi} className="monthlyPanchang-calendar-row">
            {week.map((dayData, di) => (
              <div
                key={di}
                className="monthlyPanchang-calendar-cell"
                onClick={() => setSelectedDay(dayData)}
              >
                {/* Show only day number without leading zero */}
                <div className="date">
    {(() => {
      // Parse the date string from API
      const parts = dayData.date.split("/");
      if (parts.length === 3) {
        // If format is DD/MM/YYYY or YYYY/MM/DD
        const day = parseInt(parts[0], 10);
        // If day > 31, then assume it's YYYY/MM/DD, so pick last part as day
        return day > 31 ? parseInt(parts[2], 10) : day;
      }
      return dayData.date; // fallback
    })()}
  </div>
                <div className="monthlyPanchang-mini-text">{dayData.tithi?.name}</div>
                <div className="monthlyPanchang-mini-text">{dayData.nakshatra?.name}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="container">
      <div className="ra-main-monthlyPanchang">

<div
  className="DailyPanchang-top-buttons"
  style={{
    marginBottom: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* Top Buttons */}
          <div
            className="DailyPanchang-top-buttons"
            style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* Calendar Logo SVG */}
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                style={{ marginRight: "0.75rem" }}
              >
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="16"
                  rx="2"
                  stroke="#333"
                  strokeWidth="2"
                  fill="#f5f5f5"
                />
                <path
                  d="M16 3v4M8 3v4"
                  stroke="#333"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
                <path d="M3 9h18" stroke="#333" strokeWidth="2" />
              </svg>
  
               <Link to="/panchang" style={{ textDecoration: "none",marginRight: "10px"  }}>
              <button type="button">📅 Daily Panchang</button>
            </Link>
               
              <Link to="/Hora" style={{ textDecoration: "none", marginRight: "10px" }}>
                <button type="button">Hora</button>
              </Link>
              <Link to="/Choghadiya" style={{ textDecoration: "none",marginRight: "10px"  }}>
                <button type="button">Choghadiya</button>
              </Link>
              
            </div>
          </div>
</div>

      <h2>Monthly Panchang Calendar</h2>

      <div className="monthlyPanchang-input-section">
        <label>
          Date:
          <input
            type="text"
            value={params.date}
            onChange={(e) => setParams({ ...params, date: e.target.value })}
          />
        </label>
        <label>
          Time:
          <input
            type="text"
            value={params.time}
            onChange={(e) => setParams({ ...params, time: e.target.value })}
          />
        </label>
        <label>
          Language:
          <select value={language} onChange={(e) => setLanguage(e.target.value)}>
            <option value="en">English</option>
            <option value="hi">Hindi</option>
            <option value="be">Bengali</option>
            <option value="ta">Tamil</option>
            <option value="te">Telugu</option>
            <option value="ka">Kannada</option>
            <option value="ml">Malayalam</option>
            <option value="mr">Marathi</option>
            <option value="gr">Gujarati</option>
          </select>
        </label>
        <button onClick={fetchMonthlyPanchang}>
          {loading ? "Loading..." : "Get Monthly Panchang"}
        </button>
      </div>

      {error && <p className="monthlyPanchang-error">{error}</p>}

      {loading ? <p className="monthlyPanchang-loading">Loading data...</p> : renderCalendar()}

      {selectedDay && (
        <div className="monthlyPanchang-modal-overlay" onClick={() => setSelectedDay(null)}>
          <div className="monthlyPanchang-modal-card" onClick={(e) => e.stopPropagation()}>
            <h3>🪔 Panchang for {parseInt(selectedDay.date.split("/")[0], 10)}</h3>
            <p>
              <strong>Day:</strong> {selectedDay.day?.name}
            </p>
            <p>
              <strong>Tithi:</strong> {selectedDay.tithi?.name}
            </p>
            <p>
              <strong>Nakshatra:</strong> {selectedDay.nakshatra?.name}
            </p>
            <p>
              <strong>Yoga:</strong> {selectedDay.yoga?.name}
            </p>
            <p>
              <strong>Karana:</strong> {selectedDay.karana?.name}
            </p>
            <p>
              <strong>Rasi:</strong> {selectedDay.rasi}
            </p>
            <p>
              <strong>Sunrise:</strong> {selectedDay.advanced_details?.sun_rise}
            </p>
            <p>
              <strong>Sunset:</strong> {selectedDay.advanced_details?.sun_set}
            </p>
            <p>
              <strong>Rahukaal:</strong> {selectedDay.rahukaal}
            </p>
            <p>
              <strong>Gulika:</strong> {selectedDay.gulika}
            </p>
            <p>
              <strong>Yamakanta:</strong> {selectedDay.yamakanta}
            </p>
            <button className="monthlyPanchang-close-btn" onClick={() => setSelectedDay(null)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}

export default MonthlyPanchang;
